// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          textTransform: 'none',
          borderRadius: '8px',
          padding: '6px 16px',
          height: '34px',
          fontSize: '13px',
          transition: 'all 0.15s ease-in-out',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
            transform: 'translateY(-1px)'
          }
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
          }
        },
        containedPrimary: {
          background: isDark ? '#14B8A6' : 'linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)',
          color: '#ffffff',
          boxShadow: isDark ? 'none' : '0 4px 12px 0 rgba(20, 184, 166, 0.25)',
          '&:hover': {
            background: isDark ? '#0D9488' : '#0F766E',
            boxShadow: isDark ? 'none' : '0 6px 16px 0 rgba(20, 184, 166, 0.45)',
            transform: isDark ? 'none' : 'translateY(-1px)'
          }
        },
        containedSecondary: {
          backgroundColor: isDark ? (theme.palette?.background?.raised || '#272B33') : '#FFFFFF',
          border: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #CBD5E1',
          color: isDark ? (theme.palette?.text?.primary || '#ECEEF1') : '#475569',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: isDark ? (theme.palette?.background?.hover || '#2A2E36') : '#F8FAFC',
            color: isDark ? '#FFFFFF' : '#FFFFFF',
            boxShadow: 'none'
          }
        },
        outlined: {
          border: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #CBD5E1',
          backgroundColor: isDark ? (theme.palette?.background?.input || '#1A1D23') : '#FFFFFF',
          color: isDark ? (theme.palette?.text?.primary || '#ECEEF1') : '#475569',
          '&:hover': {
            border: isDark ? '1px solid rgba(255, 255, 255, 0.13)' : '1px solid #94A3B8',
            backgroundColor: isDark ? (theme.palette?.background?.hover || '#2A2E36') : '#F8FAFC',
            color: isDark ? '#FFFFFF' : '#FFFFFF'
          }
        }
      }
    }
  };
}
